import React, { useCallback, useState } from 'react';
import { Box, Leftrow, Row, Subtitle, Tag, Title } from '../style';
import ModalCustom from '../../models/modal';
import VercelIntegrationModal from '../../models/vercelIntegrationModal/vercelIntegrationModal';
import { useDispatch } from 'react-redux';
import { setVercelProject } from '../../../services/vercelService';
import { rootStore } from '../../../mobx/rootStore';
import { error } from 'highcharts';
import { observer } from 'mobx-react-lite';
import { VercelProject } from '../../../mobx/interfaces/project';

const VercelSettingCard = () => {
  //State variables
  const [isVercelProjectModelOpen, setIsVercelProjectModelOpen] = useState(false);
  //Mobx store variables
  const { projectStore } = rootStore;
  const { currentProject } = projectStore;
  //Other variables
  const dispatch = useDispatch();

  // function to set repositories
  const handleSelectVercelProject = useCallback(
    async (project: VercelProject) => {
      try {
        const response = await dispatch(setVercelProject(currentProject?.id, project));
        if (response) {
          currentProject?.setVercelProject(project);
          setIsVercelProjectModelOpen(false);
        }
      } catch (e) {
        console.log('error', error);
      }
    },
    [currentProject, dispatch]
  );

  // select repo model open
  const openVercelProjectSelector = useCallback(() => {
    setIsVercelProjectModelOpen(true);
  }, []);

  // select repo model close
  const closeVercelProjectSelector = useCallback(() => {
    setIsVercelProjectModelOpen(false);
  }, []);
  return (
    <>
      <Box>
        <Row>
          <Leftrow>
            <Title>Vercel account</Title>
            {/* show project name */}
            <Subtitle>{currentProject?.vercelProject?.name}</Subtitle>
          </Leftrow>

          {/* project is selected */}
          <Tag onClick={openVercelProjectSelector}>Change</Tag>
        </Row>
      </Box>
      <ModalCustom open={isVercelProjectModelOpen} width={460} onClose={closeVercelProjectSelector}>
        <VercelIntegrationModal onClose={closeVercelProjectSelector} handleSelect={handleSelectVercelProject} />
      </ModalCustom>
    </>
  );
};

export default observer(VercelSettingCard);
